export const LOADING_DASHBOARD_JEFE_OBJETIVOS = "LOADING_DASHBOARD_JEFE_OBJETIVOS";
export const GET_DASHBOARD_JEFE_OBJETIVOS = "GET_DASHBOARD_JEFE_OBJETIVOS";
export const DASHBOARD_JEFE_OBJETIVOS_FAIL = "DASHBOARD_JEFE_OBJETIVOS_FAIL";

